import React, { useState }            from 'react';
import Grid                           from '@mui/material/Grid';
import Toolbar                        from '../../common/typography/Toolbar';
import HasRight                       from '../../Route/HasRight';
import Button                         from '../../common/inputs/Button';
import LinkIcon                       from '@mui/icons-material/Link';
import TableContainer                 from '@mui/material/TableContainer';
import Table                          from '@mui/material/Table';
import TableHead                      from '@mui/material/TableHead';
import TableRow                       from '@mui/material/TableRow';
import TableCell                      from '@mui/material/TableCell';
import TableBody                      from '@mui/material/TableBody';
import MaterialLink                   from '@mui/material/Link';
import { Link }                       from 'react-router-dom';
import { getStoreWarehouseEditRoute } from '../../../router/routes/store/factory/store';
import IconButton                     from '@mui/material/IconButton';
import DeleteForeverIcon              from '@mui/icons-material/DeleteForever';
import EmptyGoods                     from '../../common/store/shop/EmptyGoods';
import LinkGoodDialog                 from '../../common/store/shop/LinkGoodDialog';
import { useTranslation }             from 'react-i18next';

const Deliverables = ({ deliverables, setDeliverables, creating = false }) => {
	const { t } = useTranslation();
	const [showLinkDialog, setShowLinkDialog] = useState(false);

	const handleDelete = d => {
		setDeliverables(deliverables.filter(del => del.Catalog_Deliverable__ !== d.Catalog_Deliverable__));
	};

	const handleAdd = (d) => {
		setDeliverables([...deliverables, d]);
	};

	return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
				<Toolbar title={t('product_goods')}>
					<HasRight manager>
						<Button
							endIcon={<LinkIcon/>}
							onClick={() => setShowLinkDialog(true)}
							variant='contained'
							color='primary'
							disabled={creating}
						>
							{t('link_btn')}
						</Button>
					</HasRight>
				</Toolbar>
			</Grid>
            <Grid item xs={12}>
				{deliverables.length > 0 &&
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell> {t('tablecell_deliverable_name')}</TableCell>
								<TableCell> {t('tablecell_deliverable_style')}</TableCell>
								<TableCell align='right'/>
							</TableRow>
						</TableHead>
						<TableBody>
							{deliverables.map(g =>
								<TableRow key={g.Catalog_Deliverable__}>
									<TableCell>
										<MaterialLink
											component={Link}
											to={getStoreWarehouseEditRoute(g.Catalog_Deliverable__)}>
											{g.Name}
										</MaterialLink>
									</TableCell>
									<TableCell> {t('deliverable_style_' + g.Style)}</TableCell>
									<TableCell align='right'>
										<HasRight admin>
											<IconButton
                                                disabled={creating}
                                                color='secondary'
                                                onClick={() => handleDelete(g)}
                                                size="large">
												<DeleteForeverIcon/>
											</IconButton>
										</HasRight>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				}
				{deliverables.length < 1 && <EmptyGoods/>}
				<LinkGoodDialog
					existing={deliverables}
					linkCallback={handleAdd}
					open={showLinkDialog}
					setOpen={setShowLinkDialog}
				/>
			</Grid>
        </Grid>
    );
};

export default Deliverables;
